{
	"errorPage.404.button": "Back to Homepage",
	"errorPage.404.code": "404 error",
	"errorPage.404.description": "Sorry, the page you are looking for doesn’t exist or has been moved.",
	"errorPage.404.title": "Page not found...",
	"errorPage.network.description": "We were unable to load the page.\nPlease check your internet settings and try again.",
	"errorPage.network.title": "An error occurred...",
	"global.refreshButton": "Refresh",
	"global.toast.error.message": "An error occurred, please try again.",
	"global.toast.error.title": "Error"
}
